import React from 'react';
import { ColorPicker } from '@/components/ui/color-picker';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface ColorFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (_value: string) => void;
  placeholder?: string;
  error?: string;
}

const normalizeColor = (val: string): string => {
  const v = (val || '').trim().toUpperCase();
  if (!v) return '#000000';
  const hex = v.startsWith('#') ? v : `#${v}`;
  if (/^#([0-9A-F]{3}|[0-9A-F]{6})$/.test(hex)) return hex;
  return '#000000';
};

export const ColorField: React.FC<ColorFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  error,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="flex items-center gap-3">
        <ColorPicker
          value={normalizeColor(value)}
          onChange={onChange}
          aria-label={label}
        />
        <Input
          type="text"
          value={/^#?[0-9a-fA-F]{3,6}$/.test((value || '').trim()) ? normalizeColor(value) : (value || '')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value.trim().toUpperCase())}
          placeholder={placeholder}
          className={cn(
            error ? 'border-red-500 focus:border-red-500' : '',
            'flex-1'
          )}
        />
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

